import clsx from "clsx"
import { type ComponentProps, type ForwardedRef, forwardRef } from "react"

export const CustomIconButton = forwardRef(({ className, ...props }: ComponentProps<"button">, ref: ForwardedRef<HTMLButtonElement>) => {
  return (
    <button
      className={clsx("flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-background", className)}
      ref={ref}
      {...props}
    />
  )
})
